import React from 'react'
import type { AuthenticatedAccount } from '../types'
import { AuthenticatedAccountContext } from '../context'

export const useAuthenticatedAccount = (): AuthenticatedAccount => {
  const context = React.useContext(AuthenticatedAccountContext)

  if (!context) {
    throw new Error(
      'useAuthenticatedAccount() may be used only in the context of a <RequireAuth> component'
    )
  }

  return context
}
